<template>
  <SectionView class="diet" :title="$t('dietAdvice.title')" >
    <div v-if="$slots.action" class="header-action">
      <slot name="action"></slot>
    </div>
    <!-- 不耐受食物部分 - 已隐藏 -->
    <!-- <div class="life-title">{{ $t('dietAdvice.recentDietAdvice') }}</div>

    <template v-if="useless && useless.length > 0">
      <div class="food-section">
        <div class="section-header">
          <span class="count">{{useless.length}}</span>
          <span class="title">{{ $t('dietAdvice.notRecommendedFoods') }}</span>
          <span class="subtitle">{{ $t('dietAdvice.reduceIntake') }}</span>
        </div>
        <div class="food-grid">
          <div v-for="(item, index) in useless" :key="'useless-'+index" class="food-item">
            <img :src="item.report_food_url" :alt="$t('common.foodImage')"/>
            <div>{{item.report_food_name}}</div>
          </div>
        </div>
      </div>
      <div class="item-divider"></div>
    </template>
    <template v-else>
      <div class="food-section">
        <div class="section-header">
          <span class="count">0</span>
          <span class="title">{{ $t('dietAdvice.notRecommendedFoods') }}</span>
          <span class="subtitle">{{ $t('dietAdvice.reduceIntake') }}</span>
        </div>
        <div class="empty-message">{{ $t('dietAdvice.noNotRecommendedFoods') }}</div>
      </div>
    </template> -->

    <!-- 适宜食物部分 -->
    <div class="life-title">{{ $t('dietAdvice.recentDietAdvice') }}</div>
    <template v-if="useful && useful.length > 0">
      <div class="food-section useful-section">
        <div class="section-header">
          <span class="count">{{useful.length}}</span>
          <span class="title">{{ $t('dietAdvice.recommendedFoods') }}</span>
          <span class="subtitle">{{ $t('dietAdvice.recommendedSupplement') }}</span>
        </div>
        <div class="food-grid">
          <div v-for="(item, index) in useful" :key="'useful-'+index" class="food-item">
            <img :src="item.report_food_url" :alt="$t('common.foodImage')"/>
            <div>{{item.report_food_name}}</div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="suggestionData &&suggestionData.length">
      <div v-if="!isCollapsed">
        <div class="life-title">{{ $t('dietAdvice.lifestyleImprovement') }}</div>
        <div class="improve-content" v-for="(item,index) in suggestionData" :key="index">
          <div class="improve-item">
            <!-- <img class="improve-icon" src="/src/assets/motion.png" /> -->
            <img class="improve-icon"  :src="require(`@/assets/${item.type===1?'motion':item.type===2?'drinking':'sleep'}.png`)"/>
            <div class="improve-section">
              <div class="improve-title">{{item.topic}}</div>
              <div class="improve-text">{{item.content}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="collapse-button" @click="toggleCollapse">
      <span>{{ isCollapsed ? $t('actions.expandMore') : $t('actions.collapse') }}</span>
      <img
        :src="
          require(`@/assets/AIUnscramble/${
            isCollapsed ? 'Down.png' : 'up.png'
          }`)
        "
        class="collapse-arrow-icon"
        :alt="isCollapsed ? $t('actions.expandMore') : $t('actions.collapse')"
      />
    </div>
    </template>

    <!-- 弹窗 -->
    <dialog-view :title="$t('dietAdvice.title')" v-model="dialog">
      {{ $t('dietAdvice.dietAdviceDialog') }}
    </dialog-view>
    
  </SectionView>
</template>

<script>
  import SectionView from "@/components/SectionView";
  import DialogView from "./DialogView";

  /**
   * 饮食建议卡片
   */
  export default {
    name: "DietCard",
    components: {DialogView, SectionView},

    props: {
      // 耐受食物
      useful: {
        type: Array,
        require: false
      },
      // 不耐受食物
      useless: {
        type: Array,
        require: false
      },
      suggestionData: {
        type: Array,
        require: false
      }
    },

    data() {
      return {
        dialog: false,
        isCollapsed:false
      }
    },
    methods:{
      toggleCollapse() {
        this.isCollapsed = !this.isCollapsed;
      },
    }
  }
</script>

<style lang="scss" scoped>
  .diet {
    padding:0 30px ;
    box-sizing: border-box;
    .header-action {
      margin-bottom: 32px;
    }
    .food-section {
      margin-bottom: 15px;
      border-radius: 10px;
      // padding: 20px;
      
      &.useful-section {
        margin-top: 40px;
        
        .section-header {
          .count {
            color: #003BBF;
          }
          
          .subtitle {
            color: #999;
          }
        }
      }
    }
    
    .section-header {
      margin-bottom: 20px;
      display: flex;
      align-items: baseline;
      
      .count {
        font-size: 36px;
        font-weight: bold;
        color: #FF5B4D;
        margin-right: 10px;
      }
      
      .title {
        font-size: 28px;
        font-weight: 500;
        color: #333;
        margin-right: 15px;
      }
      
      .subtitle {
        font-size: 24px;
        color: #999;
      }
    }
    
    .food-grid {
      display: flex;
      flex-wrap: wrap;
      margin: 0 -10px;
    }
    
    .food-item {
      width: 135px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 30px;
      margin-top: 20px;
      margin-left: 30px;
      
      img {
        width: 68px;
        height: 68px;
        object-fit: cover;
        margin-bottom: 12px;
      }
      
      div {
        font-weight: 400;
font-size: 20px;
color: #00133D;
line-height: 14px;
text-align: center;
font-style: normal;
text-transform: none;
      }
    }
    
    .empty-message {
      text-align: center;
      padding: 30px 0;
      color: #999;
      font-size: 28px;
    }
    .item-divider {
  width: 100%;
  height: 1px;
  border-top: 2px dashed #DFDFDF; /* 将实线背景改为虚线边框 */
  background-color: transparent; /* 移除背景色 */
}
  }
  .collapse-button {
  text-align: center;
  padding: 15px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: 5px 0;
  font-size: 28px;
}
.life-title{
  color:#2C324E;
  font-size: 30px;
  font-weight: bold;
  margin-bottom: 40px;
}
.improve-content{
  .improve-item{
    // width: 90%;
    // background: pink;
    display: flex;
    margin-bottom: 50px;
    .improve-icon{
      width: 70px;
      height: 70px;
      margin-right: 30px;
    }
    .improve-section{
      // flex:1;
      font-size: 28px;
      .improve-title{
        color: #2C324E;
        font-weight: bold;
        margin-bottom: 20px;

      }
      .improve-text{
        color: #495880;
      }
    }
  }
}
</style>
